import React from 'react';
import { Stack, Chip, Typography } from '@mui/material';
import FilePreviewTooltip from '../../../../../../files/components/FilePreveiwTooltip';
import FileThumbnail from '../../../../../../files/components/FileThumbnail';

export function AttachmentList({ attachments = [] }) {
  if (attachments.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        -
      </Typography>
    );
  }

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      {attachments.slice(0, 3).map((attachment) => {
        return (
          <FilePreviewTooltip key={attachment.attachment_id} file={attachment}>
            <span>
              <FileThumbnail fileId={attachment.file_id} filetype={attachment.filetype} filename={attachment.file_name} />
            </span>
          </FilePreviewTooltip>
        );
      })}
      {attachments.length > 3 && (
        <Chip
          label={`+${attachments.length - 3}`}
          size="small"
          color="primary"
          sx={{ height: 24 }}
        />
      )}
    </Stack>
  );
}
